<template>
  <div>
<!--    <el-button type="primary" @click="handleAdd">新增</el-button>-->
    
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column type="index" label="序号" width="80"></el-table-column>
      <el-table-column prop="batch" label="批次" width="200"></el-table-column>
      <el-table-column prop="price" label="单价"width="200"></el-table-column>
      <el-table-column prop="num" label="数量"width="200"></el-table-column>
      <el-table-column prop="description" label="备注"width="500"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';

export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      tableData: [],
      // 添加分页参数
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      bomDialogVisible: false,
      dialogTitle: '',
      currentMaterialId: null,
      form: {
        id: null,
        name: '',
        material_type: ''
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 查询数据
    async fetchData() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_details_with_num",
          parameters: [this.id]
        });
        this.tableData = response.data;
        this.total = response.data.total; // 假设返回总记录数在totalElements字段
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 添加分页事件处理方法
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
  }
};
</script>

<style scoped>
.el-button {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>